import {useEffect, useState} from 'react';

import {useTheme} from '@mui/material';
import {useWindowSize} from '@uidotdev/usehooks';

import {BREAKPOINTS} from '../../const';

const useBreakpoint = () => {
  const windowSize = useWindowSize();
  const theme = useTheme();

  const getCurrentBreakpoint = width => {
    const {xs, sm, md, lg, xl} = theme.breakpoints.values;

    if (width < sm) return BREAKPOINTS.xs;
    if (width < md) return BREAKPOINTS.sm;
    if (width < lg) return BREAKPOINTS.md;
    if (width < xl) return BREAKPOINTS.lg;
    return BREAKPOINTS.xl;
  };

  const initialBreakpoint = typeof window !== 'undefined' ? getCurrentBreakpoint(window.innerWidth) : null;

  const [breakpoint, setBreakpoint] = useState(initialBreakpoint);

  useEffect(() => {
    if (!windowSize.width) return;

    const currentBreakpoint = getCurrentBreakpoint(windowSize.width);
    setBreakpoint(currentBreakpoint);
  }, [windowSize.width]);

  return breakpoint;
};

export default useBreakpoint;
